import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { containerSx } from '../modules/components/Section';

/** ヒーローの外枠。写真・グラデーション暗幕・左下のコピー枠を組み立てる。 */
function ProductHeroLayout(props) {
  const { sxBackground, aside, children } = props;

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        height: { xs: 600, sm: 720 },
        display: 'flex',
        alignItems: 'flex-end',
        overflow: 'hidden',
        color: '#ffffff',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          zIndex: 0,
          ...sxBackground,
        }}
      />
      {/* 黒50%のベタ暗幕をやめ、下から上へ抜けるグラデーションにする */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(to top, rgba(24,27,22,.72) 0%, rgba(24,27,22,.25) 45%, rgba(24,27,22,.15) 100%)',
          zIndex: 1,
        }}
      />
      {aside}
      <Box sx={{ ...containerSx, position: 'relative', zIndex: 2, pb: { xs: 8, sm: 11 } }}>{children}</Box>
    </Box>
  );
}

ProductHeroLayout.propTypes = {
  aside: PropTypes.node,
  children: PropTypes.node,
  sxBackground: PropTypes.object,
};

export default ProductHeroLayout;
